import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function RecordDialog({ kind, cfg, statuses, record, open, onOpenChange, onSave }) {
  const [form, setForm] = useState({});
  useEffect(() => setForm(record || { status: statuses[0] }), [record, statuses, open]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] max-w-2xl overflow-y-auto" data-testid={`${kind}-dialog`}>
        <DialogHeader>
          <DialogTitle>{record ? "Edit record" : `New ${cfg.title.toLowerCase()} entry`}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Status</Label>
            <Select value={form.status || statuses[0]} onValueChange={(v) => set("status", v)}>
              <SelectTrigger data-testid={`${kind}-field-status`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {statuses.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {cfg.fields.map((f) => (
            <div key={f.key} className="space-y-1.5">
              <Label>{f.label}</Label>
              {f.long ? (
                <Textarea rows={2} value={form[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`${kind}-field-${f.key}`} />
              ) : (
                <Input value={form[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`${kind}-field-${f.key}`} />
              )}
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={() => onSave(form)} className="bg-accent font-bold hover:bg-accent/90" data-testid={`${kind}-save-btn`}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
